import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../axiosInstance";

import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from "../components/Pagination";
import { errorMessage } from "../hooks/UserLogs";
export default function Customer() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListCustomers, setListCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [firstNameUp, setFirstNameUp] = useState("");
  const [lastNameUp, setLastNameUp] = useState("");
  const [middleNameUp, setMiddleNameUp] = useState("");
  const [profileUp, setprofileUp] = useState("");
  const [addressUp, setAddressUp] = useState("");
  const [phoneUp, setPhoneUp] = useState("");
  const [emailUp, setEmailup] = useState("");
  const [genderUp, setGenderUp] = useState("");
  const [errorForm, setErrorForm] = useState({});
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowError] = useState(false);
  const [idUp, setIdUp] = useState(0);
  let header =
  {
    'Content-Type': 'application/json'
  };

  const handleClose = () => {
    setErrorForm({});
    setFirstNameUp("")
    setLastNameUp("")
    setMiddleNameUp("")
    setGenderUp("");
    setEmailup("")
    setIdUp(0);
    setPhoneUp("")
    setView(false)

  }
  const viewClose = () => {
    setView(false)
  }

  const axiosInstance = axios.create({
                withCredentials: true,
              })

  const viewUpdate = (id, firstName, lastName, middleName, profile, address) => {
    setIdUp(id);
    setAddressUp(address);
    setMiddleNameUp(middleName);
    setLastNameUp(lastName);
    setFirstNameUp(firstName);
    setprofileUp(profile);
    setView(true)
  }
  const handleCloseError = () => {
    setShowError(false);
  }
  const updateCustomer = () => {
    let error = {};
    let isvalid = true;

    if (firstNameUp == "") {
      error.firstNameUp = "Field is required!";
      isvalid = false;
    }
    if (lastNameUp == "") {
      error.lastNameUp = "Field is required!";
      isvalid = false;
    }

    if (addressUp == "") {
      error.addressUp = "Field is required!";
      isvalid = false;
    }
    if (profileUp == "") {
      error.profileUp = "Field is required!";
      isvalid = false;
    }

    setErrorForm(error);

    if (isvalid) {
      setIsLoading(true);
      axiosInstance.put(bUrl + "/customer-wallet/update-by-staff",

        //birthDay: birthDay,
        {
          "id": idUp,
          "firstName": firstNameUp,
          "lastName": lastNameUp,
          "middleName": middleNameUp,
          "profile": profileUp,
          "address": addressUp,
          "fkIdStaff":sessionStorage.getItem("idUser")
        }

        , { header: header })
        .then(function (response) {
          //getDayOffDayEmmp(idEmp);
          setIsLoading(false)

          handleClose()
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            seterrMsg(msg);
            setShowError(true);
          } else {
            getListCustomers(email, phone, code);
          }

        })
        .catch(function (err) {
          setIsLoading(false)

          if (err?.response?.status == 401 || err?.response?.status == 403) {
            seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
            setShowError(true);
          }else{
            let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
            seterrMsg(msg);
            setShowError(true);
          }
        });
    }
  }

  const updateForm = () => { }

  const bUrl = process.env.REACT_APP_B_URL;

  const { id } = useParams();
  const navigate = useNavigate();
  const getListCustomers = async (email, phone, code) => {
    let ulr = "/customer-wallet/find-all-customers?page=" + currentPage + "&limit=10";
    setCode(code);
    setEmail(email);
    setPhone(phone);
    if (code != '' | phone != '' | email != '') {
      ulr = "/customer-wallet/find-all-customers?page=" + currentPage + "&limit=10";
      // if (email != '') {
      //   ulr += "&email=" + email;
      // }
      // if (code != '') {
      //   ulr += "&code=" + code;
      // }
      if (phone != '') {
        ulr += "&phone=" + phone;
      }
      
    }
    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
      
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        seterrMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
      }else{
        let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
        seterrMsg(msg);
        setShowError(true);
      }

      setIsLoading(false)

    });
    if (response) {
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      }else{
        setListCustomers(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
      }

      if (response.status == 401) {
        navigate('/backoffice/login');
      }
      
      setIsLoading(false);
    }
  }
  

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  useEffect(() => {
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getListCustomers(email, phone, code);
  }, [currentPage])

  return (
    <div className="App">
      <div className="">


        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'>Clients</p></div>
                <div><Topbar /></div>
              </div>
              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <input type="email" onChange={(e) => getListCustomers(e.target.value, phone, code)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="phone">Phone</label>
                    <input type="text" onChange={(e) => getListCustomers(email, e.target.value, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="code">Code</label>
                    <input type="text" onChange={(e) => getListCustomers(email, phone, e.target.value)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                  </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">




                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">Id</th>
                          <th scope="col">Prénom</th>
                          <th scope="col">Deuxieme Nom</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Téléphone</th>
                          <th scope="col">Date</th>
                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListCustomers.length > 0 ? ListCustomers.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            <td>{a.firstName}</td>
                            <td>{a.middleName}</td>
                            <td>{a.lastName}</td>
                            <td>{a.phone}</td>
                            <td>{formatDate(a.createdDate)}</td>
                            <td>
                              <Link to={"/accountingOpByCustomer/" + a.fkIdAccounting}><i className='bx bx-folder-open' title="Opérations"></i></Link>
                              &nbsp;
                              <Link to={"/customers/" + a.idCustomerWallet}><i className='bx bx-notepad' title="Détails"></i></Link>
                              &nbsp;
                              <i onClick={() => viewUpdate(a.idCustomerWallet, a.firstName, a.lastName, a.middleName, a.profile, a.address)} className='bx bx-edit-alt colore-icon' title="Update"></i>
                            </td>
                            {/* <td><Link to={"/collections/"+a.hashids+"/byAgent/"}>Dépots</Link></td> */}

                          </tr>
                        }) : <tr></tr>}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={handleClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Agency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group mb-2">
              <input type="text" placeholder="Prénom" name="firstname" className='form-control ' value={firstNameUp} onChange={(e) => setFirstNameUp(e.target.value)} />
              {errorForm.firstNameUp != "" && <p style={{ color: 'red' }}>{errorForm.firstNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Deuxième Nom" name="middlename" className='form-control ' value={middleNameUp} onChange={(e) => setMiddleNameUp(e.target.value)} />
              {errorForm.middleNameUp != "" && <p style={{ color: 'red' }}>{errorForm.middleNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Nom" name="lastname" className='form-control ' value={lastNameUp} onChange={(e) => setLastNameUp(e.target.value)} />
              {errorForm.lastNameUp != "" && <p style={{ color: 'red' }}>{errorForm.lastNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Adresse" name="name" className='form-control ' value={addressUp} onChange={(e) => setAddressUp(e.target.value)} />
              {errorForm.addressUp != "" && <p style={{ color: 'red' }}>{errorForm.addressUp}</p>}
            </div>

            <div className="form-group">
              <select className="form-control" id="exampleFormControlSelect1" placeholder='Gender' onChange={(e) => setprofileUp(e.target.value)} value={profileUp}>
                <option >Sélectionner profil</option>

                <option value={'CUSTOMER'} selected={profileUp == "CUSTOMER"} >Customer</option>
                <option value={'AGENT'} selected={profileUp == "AGENT"} >Marchand</option>

              </select>
              {errorForm.profileUp != "" && <p style={{ color: 'red' }}>{errorForm.profileUp}</p>}
            </div>





          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {isLoading ?
            <img src='../Custom.svg' width="30%" />
            :
            <Button variant="primary" onClick={updateCustomer}>
              Modifier
            </Button>

          }
        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}